"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.U256 = exports.UInt256 = void 0;
const m = __importStar(require("./arithmetic"));
class UInt256 {
    constructor(param, radix = 10) {
        this.compareTo = this.cmp;
        this.subtract = this.sub;
        this.divideAndRemainder = this.divmod;
        this.divide = this.div;
        this.divideSigned = this.sdiv;
        this.multiply = this.mul;
        this.remainder = this.mod;
        this.shiftRight = this.shr;
        this.shiftLeft = this.shl;
        this.isMutable = false;
        if (!param) {
            return this;
        }
        if (param instanceof ArrayBuffer) {
            if (param.byteLength === m.BYTES) {
                this.buffer = param;
            }
            else {
                throw new TypeError('NAN');
            }
            return this.optimize();
        }
        if (param instanceof UInt256) {
            if (param.buffer) {
                this.buffer = param.buffer.slice(0);
            }
            return this;
        }
        if (typeof param === 'number') {
            if (param < 0 || param > m.JSNUMBER_MAX_INTEGER) {
                throw new TypeError('NAN');
            }
            if (param !== 0) {
                this.buffer = m.numberToBuffer(param);
            }
            return this;
        }
        const prefixed = 'xX'.indexOf(param[1]) !== -1;
        if (radix === 16 || prefixed) {
            this.buffer = new ArrayBuffer(m.BYTES);
            if (m.fromHex(this.buffer, param, prefixed)) {
                throw new TypeError('NAN');
            }
            return this.optimize();
        }
        if (radix > m.RADIX_MAX || radix < m.RADIX_MIN) {
            throw new TypeError('NAN');
        }
        for (let i = 0; i < param.length; i += 1) {
            const chr = parseInt(param.charAt(i), radix);
            if (isNaN(chr)) {
                throw new TypeError('NAN');
            }
            this.mul(radix, true).add(chr, true);
        }
        return this;
    }
    static valueOf(val) {
        return new UInt256(val);
    }
    mutable(mutable = true) {
        this.isMutable = mutable;
        return this;
    }
    pow(rval, mutate) {
        if (rval < 0) {
            throw new Error('NAN');
        }
        const lval = (mutate && this) || this.copy();
        if (rval === 0) {
            lval.buffer = new UInt256(1).buffer;
            return lval;
        }
        if (!lval.buffer) {
            return lval;
        }
        const rv = (mutate && this.copy()) || this;
        while (--rval) {
            m.mul(lval.buffer, rv.buffer);
        }
        return lval.optimize();
    }
    add(rval, mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        if (typeof rval === 'number') {
            if (rval < 0 || rval > m.JSNUMBER_MAX_INTEGER) {
                throw new TypeError('NAN');
            }
            if (rval !== 0) {
                if (!lval.buffer) {
                    lval.buffer = m.numberToBuffer(rval);
                    return lval;
                }
                m.add(lval.buffer, rval);
                lval.optimize();
            }
            return lval;
        }
        if (!rval.buffer) {
            return lval;
        }
        if (!lval.buffer) {
            lval.buffer = rval.buffer.slice(0);
            return lval;
        }
        m.add(lval.buffer, rval.buffer);
        return lval.optimize();
    }
    safeAdd(rval, mutate = this.isMutable) {
        const res = this.add(rval);
        if (this.gt(res)) {
            throw new TypeError('OF');
        }
        if (mutate) {
            this.buffer = res.buffer;
            return this;
        }
        return res;
    }
    gcd(rval, mutate = this.isMutable) {
        let t = this.mod(rval);
        let num = rval.copy();
        let denom = t;
        while (denom.neq(0)) {
            t = num.mod(denom, true);
            num = denom;
            denom = t;
        }
        if (!mutate) {
            return num;
        }
        this.buffer = num.buffer;
        return this;
    }
    sub(rval, mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        if (typeof rval === 'number') {
            if (rval < 0 || rval > m.JSNUMBER_MAX_INTEGER) {
                throw new TypeError('NAN');
            }
            if (rval !== 0) {
                if (!lval.buffer) {
                    lval.buffer = m.numberToBuffer(rval);
                    m.comp(lval.buffer);
                    return lval;
                }
                m.sub(lval.buffer, rval);
                lval.optimize();
            }
            return lval;
        }
        if (!rval.buffer) {
            return lval;
        }
        if (!lval.buffer) {
            lval.buffer = rval.buffer.slice(0);
            m.comp(lval.buffer);
            return lval;
        }
        m.sub(lval.buffer, rval.buffer);
        return lval.optimize();
    }
    safeSub(rval, mutate = this.isMutable) {
        if (this.lt(rval)) {
            throw new TypeError('OF');
        }
        return this.sub(rval, mutate);
    }
    divmod(rval) {
        const lval = this.copy();
        rval = new UInt256(rval);
        if (!lval.buffer) {
            return [lval, lval.copy()];
        }
        if (m.divmod(lval.buffer, rval.buffer)) {
            throw new TypeError('DBZ');
        }
        return [rval.optimize(), lval.optimize()];
    }
    div(rval, mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        if (!lval.buffer) {
            return lval;
        }
        rval = new UInt256(rval);
        if (rval.eq(0)) {
        }
        if (m.divmod(lval.buffer, rval.buffer)) {
            rval = new UInt256(0);
        }
        lval.buffer = rval.buffer;
        return lval.optimize();
    }
    sdiv(rval, mutate = this.isMutable) {
        let lval = (mutate && this) || this.copy();
        rval = new UInt256(rval);
        const maxInt256 = new UInt256(m.MAX_INT256, 16);
        const negateResult = rval.gt(maxInt256) && !lval.gt(maxInt256) ||
            lval.gt(maxInt256) && !rval.gt(maxInt256);
        lval = lval.gt(maxInt256) ? lval.negate() : lval;
        rval = rval.gt(maxInt256) ? rval.negate() : rval;
        lval = lval.div(rval);
        if (negateResult)
            lval = lval = lval.negate();
        return lval.optimize();
    }
    mod(rval, mutate = this.isMutable) {
        let lval = (mutate && this) || this.copy();
        if (!lval.buffer) {
            return lval;
        }
        rval = new UInt256(rval);
        if (m.divmod(lval.buffer, rval.buffer)) {
            lval = new UInt256(0);
        }
        return lval.optimize();
    }
    smod(rval, mutate = this.isMutable) {
        let lval = (mutate && this) || this.copy();
        rval = new UInt256(rval);
        const maxInt256 = new UInt256(m.MAX_INT256, 16);
        const negateResult = rval.gt(maxInt256) && lval.gt(maxInt256) ||
            lval.gt(maxInt256);
        lval = lval.gt(maxInt256) ? lval.negate() : lval;
        rval = rval.gt(maxInt256) ? rval.negate() : rval;
        lval = lval.mod(rval);
        if (negateResult)
            lval = lval = lval.negate();
        return lval.optimize();
    }
    mul(rval, mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        if (!lval.buffer) {
            return lval;
        }
        if (typeof rval === 'number') {
            if (rval < 0 || rval > m.JSNUMBER_MAX_INTEGER) {
                throw new TypeError('NAN');
            }
            if (rval === 0) {
                delete lval.buffer;
                return lval;
            }
            m.mul(lval.buffer, rval);
            return lval.optimize();
        }
        if (!rval.buffer) {
            delete lval.buffer;
            return lval;
        }
        m.mul(lval.buffer, rval.buffer);
        return lval.optimize();
    }
    safeMul(rval, mutate = this.isMutable) {
        if (this.eq(0)) {
            return (mutate && this) || this.copy();
        }
        const res = this.mul(rval);
        if (res.div(this).neq(rval)) {
            throw new TypeError('OF');
        }
        if (mutate) {
            this.buffer = res.buffer;
            return this;
        }
        return res;
    }
    and(rval, mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        if (!lval.buffer) {
            return lval;
        }
        if (typeof rval === 'number') {
            if (rval < 0 || rval > m.JSNUMBER_MAX_INTEGER) {
                throw new TypeError('NAN');
            }
            if (rval === 0) {
                delete lval.buffer;
                return lval;
            }
            m.and(lval.buffer, rval);
            return lval;
        }
        if (!rval.buffer) {
            delete lval.buffer;
            return lval;
        }
        m.and(lval.buffer, rval.buffer);
        return lval;
    }
    andNot(rval, mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        if (!lval.buffer) {
            return lval;
        }
        if (typeof rval === 'number') {
            if (rval < 0 || rval > m.JSNUMBER_MAX_INTEGER) {
                throw new TypeError('NAN');
            }
            if (rval === 0) {
                return lval;
            }
            m.andNot(lval.buffer, rval);
            return lval.optimize();
        }
        if (!rval.buffer) {
            return lval;
        }
        m.andNot(lval.buffer, rval.buffer);
        return lval.optimize();
    }
    or(rval, mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        if (!lval.buffer) {
            lval.buffer = new UInt256(rval).buffer;
            return lval;
        }
        if (typeof rval === 'number') {
            if (rval < 0 || rval > m.JSNUMBER_MAX_INTEGER) {
                throw new TypeError('NAN');
            }
            if (rval === 0) {
                return lval;
            }
            m.or(lval.buffer, rval);
            return lval;
        }
        if (!rval.buffer) {
            return lval;
        }
        m.or(lval.buffer, rval.buffer);
        return lval;
    }
    xor(rval, mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        if (!lval.buffer) {
            lval.buffer = new UInt256(rval).buffer;
            return lval;
        }
        if (typeof rval === 'number') {
            if (rval < 0 || rval > m.JSNUMBER_MAX_INTEGER) {
                throw new TypeError('NAN');
            }
            if (rval === 0) {
                return lval;
            }
            m.xor(lval.buffer, rval);
            return lval.optimize();
        }
        if (!rval.buffer) {
            return lval;
        }
        m.xor(lval.buffer, rval.buffer);
        return lval.optimize();
    }
    not(mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        lval.buffer = lval.buffer || new ArrayBuffer(m.BYTES);
        m.not(lval.buffer);
        return lval.optimize();
    }
    shl(shift, mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        if (shift < 0 || shift > m.JSNUMBER_MAX_INTEGER) {
            throw new TypeError('NAN');
        }
        if (!lval.buffer) {
            return lval;
        }
        m.shl(lval.buffer, shift);
        return lval.optimize();
    }
    shr(shift, mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        if (shift < 0 || shift > m.JSNUMBER_MAX_INTEGER) {
            throw new TypeError('NAN');
        }
        if (!lval.buffer) {
            return lval;
        }
        m.shr(lval.buffer, shift);
        return lval.optimize();
    }
    sar(shift, mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        if (shift < 0 || shift > m.JSNUMBER_MAX_INTEGER) {
            throw new TypeError('NAN');
        }
        if (!lval.buffer) {
            return lval;
        }
        m.sar(lval.buffer, shift);
        return lval.optimize();
    }
    eq(rval) {
        if (typeof rval === 'number') {
            if (rval < 0 || rval > m.JSNUMBER_MAX_INTEGER) {
                throw new TypeError('NAN');
            }
            if (!this.buffer) {
                return rval === 0;
            }
            return m.eq(this.buffer, rval);
        }
        if (!this.buffer) {
            return !rval.buffer || m.eq(rval.buffer, 0);
        }
        return m.eq(this.buffer, rval.buffer || 0);
    }
    neq(rval) {
        return !this.eq(rval);
    }
    cmp(rval) {
        if (typeof rval === 'number') {
            if (rval < 0 || rval > m.JSNUMBER_MAX_INTEGER) {
                throw new TypeError('NAN');
            }
            if (!this.buffer) {
                return (rval > 0 && -1) || (rval < 0 && 1) || 0;
            }
            return m.cmp(this.buffer, rval);
        }
        if (!this.buffer) {
            if (!rval.buffer) {
                return 0;
            }
            return m.cmp(rval.buffer, 0) * -1;
        }
        return m.cmp(this.buffer, rval.buffer || 0);
    }
    cmpSigned(rval) {
        if (!this.buffer) {
            if (!rval.buffer) {
                return 0;
            }
            return m.cmpSigned(rval.buffer, 0) * -1;
        }
        return m.cmpSigned(this.buffer, rval.buffer || 0);
    }
    lte(rval) {
        return this.cmp(rval) <= 0;
    }
    lt(rval) {
        return this.cmp(rval) < 0;
    }
    slt(rval) {
        return this.cmpSigned(rval) < 0;
    }
    gte(rval) {
        return this.cmp(rval) >= 0;
    }
    gt(rval) {
        return this.cmp(rval) > 0;
    }
    sgt(rval) {
        return this.cmpSigned(rval) > 0;
    }
    copy() {
        if (!this.buffer) {
            return new UInt256();
        }
        return new UInt256(this.buffer.slice(0));
    }
    valueOf() {
        if (!this.buffer) {
            return 0;
        }
        return m.toNumber(this.buffer);
    }
    toString(radix = 10) {
        if (!this.buffer) {
            return '0';
        }
        if (radix === 16) {
            return m.toHex(this.buffer);
        }
        if (radix > m.RADIX_MAX || radix < m.RADIX_MIN) {
            radix = 10;
        }
        if (m.cmp(this.buffer, m.JSNUMBER_MAX_INTEGER) <= 0) {
            return this.valueOf().toString(radix);
        }
        let out = '';
        let divmod = [];
        divmod[0] = this;
        divmod[1] = new UInt256(0);
        do {
            divmod = divmod[0].divmod(radix);
            out = m.ALPHABET.charAt(divmod[1].valueOf() & m.BYTE_MASK) + out;
        } while (divmod[0].buffer);
        return out;
    }
    toJSON() {
        return this.toString();
    }
    toByteArray() {
        if (!this.buffer) {
            return new Uint8Array(new ArrayBuffer(m.BYTES));
        }
        return new Uint8Array(this.buffer.slice(0)).reverse();
    }
    testBit(n) {
        if (!this.buffer) {
            return false;
        }
        const buffer = this.buffer.slice(0);
        m.shr(buffer, n);
        m.and(buffer, 1);
        return m.eq(buffer, 1);
    }
    setBit(n, mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        lval.buffer = lval.buffer || new ArrayBuffer(m.BYTES);
        const nbuffer = new ArrayBuffer(m.BYTES);
        m.add(nbuffer, 1);
        m.shl(nbuffer, n);
        m.or(lval.buffer, nbuffer);
        return lval;
    }
    flipBit(n, mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        lval.buffer = lval.buffer || new ArrayBuffer(m.BYTES);
        const nbuffer = new ArrayBuffer(m.BYTES);
        m.add(nbuffer, 1);
        m.shl(nbuffer, n);
        m.xor(lval.buffer, nbuffer);
        return lval.optimize();
    }
    clearBit(n, mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        if (!lval.buffer) {
            return lval;
        }
        const nbuffer = new ArrayBuffer(m.BYTES);
        m.add(nbuffer, 1);
        m.shl(nbuffer, n);
        m.not(nbuffer);
        m.and(lval.buffer, nbuffer);
        return lval.optimize();
    }
    bitCount() {
        if (!this.buffer) {
            return 0;
        }
        return m.pop(this.buffer);
    }
    negate(mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        lval.buffer = lval.buffer || new ArrayBuffer(m.BYTES);
        m.comp(lval.buffer);
        return lval.optimize();
    }
    min(rval, mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        rval = new UInt256(rval);
        if (rval.lt(lval)) {
            lval.buffer = rval.buffer;
        }
        return lval;
    }
    max(rval, mutate = this.isMutable) {
        const lval = (mutate && this) || this.copy();
        rval = new UInt256(rval);
        if (rval.gt(lval)) {
            lval.buffer = rval.buffer;
        }
        return lval;
    }
    optimize() {
        if (!this.buffer) {
            return this;
        }
        if (m.eq(this.buffer, 0)) {
            delete this.buffer;
        }
        return this;
    }
}
exports.UInt256 = UInt256;
function U256(param, param2) {
    if (typeof param === 'string') {
        return new UInt256(param, param2);
    }
    return new UInt256(param);
}
exports.U256 = U256;
//# sourceMappingURL=uint256.js.map